import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Button, Loader, Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';

import './DataRoomWithdraw.styles.scss';

type DataRoomWithdrawProps = {
  className?: string;
  isLoading?: boolean;
  onWithdraw: (withdrawInterest: boolean) => void;
} & ModalProps;

const DataRoomWithdraw: React.ForwardRefRenderFunction<
  ModalRef,
  DataRoomWithdrawProps
> = (props, ref) => {
  const { className, isLoading, onWithdraw, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('data-room-withdraw', className);

  const { t } = useTranslation();

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('withdrawInterestQuestion')}
      {...rest}
    >
      <div className="data-room-withdraw__content">
        <p>{t('withdrawInterestSubquestion')}</p>

        {isLoading && <Loader />}

        <div className="actions">
          <Button
            variant="link"
            type="button"
            disabled={isLoading}
            onClick={() => onWithdraw(false)}
          >
            {t('illStay')}
          </Button>
          <Button
            type="button"
            disabled={isLoading}
            onClick={() => onWithdraw(true)}
          >
            {t('withdraw')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default forwardRef(DataRoomWithdraw);
